import gql from 'graphql-tag'

export const query = gql`
  query fetchPersonSystem($id: Int!) {
    records: persons_person_by_pk(id: $id) {
      id
      configWebPage:config_web_page
    }
  }
`

export default query
